import { Select, Checkbox, TextField, MenuItem } from "@mui/material";
import styles from "../../crf_builder.module.css";

export default function EntryRules(props) {
  const { field, updateField } = props;

  const toggleRule = (checked, rule_type, value, obj = {}) => {
    const { unit = null } = obj;
    if (!field.entry_rules) {
      field.entry_rules = [];
    }
    let existing = field.entry_rules.find((r) => r.rule_type === rule_type);
    if (checked) {
      if (existing) {
        existing.value = value;
        if (unit) {
          existing.unit = unit;
        }
      } else {
        let new_value = { rule_type, value };
        if (unit) {
          new_value.unit = unit;
        }
        field.entry_rules.push(new_value);
      }
    } else {
      if (existing) {
        field.entry_rules = [...field.entry_rules].filter((r) => r.rule_type !== rule_type);
      }
    }
    updateField(field.id, field);
  };

  const toggleRuleOverride = (checked) => {
    if (checked) {
      field.entry_rule_override = true;
    } else {
      delete field.entry_rule_override;
    }
    updateField(field.id, field);
  };

  const textfield_sx = {
    "& .MuiInputBase-input": {
      padding: "5px",
      paddingLeft: "10px",
      textAlign: "center",
      width: "50px",
    },
  };
  const datefield_sx = {
    "& .MuiInputBase-input": {
      padding: "5px",
      paddingLeft: "10px",
      textAlign: "center",
      width: "120px",
    },
  };
  return (
    <div>
      <div className={styles.flex_row}>
        <Checkbox
          checked={field.entry_rule_override}
          onClick={(e) => toggleRuleOverride(e.target.checked)}
          size="small"
        />
        <div>Allow Save Anyway/Override</div>
      </div>
      <div className={styles.break} />
      {["year"].includes(field.type) ? (
        <div>
          {[
            { name: "min year", rule_type: "min" },
            { name: "max year", rule_type: "max" },
            { name: "min age", rule_type: "min_age" },
            { name: "max age", rule_type: "max_age" },
            { name: "not future", rule_type: "not_future" },
            { name: "not past", rule_type: "not_past" },
          ].map((r) => (
            <div key={r.rule_type} className={styles.flex_row}>
              <Checkbox
                checked={field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)}
                onClick={(e) => toggleRule(e.target.checked, r.rule_type, "")}
                size="small"
              />
              <div>{r.name}</div>
              {!["not_future", "not_past"].includes(r.rule_type) ? (
                <div className={styles.entry_rule_text_wrapper}>
                  <TextField
                    sx={textfield_sx}
                    inputProps={{ maxLength: 4 }}
                    value={field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)?.value || ""}
                    disabled={!field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)}
                    onChange={(e) => toggleRule(true, r.rule_type, e.target.value)}
                  />
                </div>
              ) : null}
            </div>
          ))}
        </div>
      ) : null}
      {["date"].includes(field.type) ? (
        <div>
          {[
            { name: "min date", rule_type: "min" },
            { name: "max date", rule_type: "max" },
            { name: "min age", rule_type: "min_age" },
            { name: "max age", rule_type: "max_age" },
            { name: "not future", rule_type: "not_future" },
            { name: "not past", rule_type: "not_past" },
            {
              name: "after randomization date",
              rule_type: "after_randomization",
            },
          ].map((r) => (
            <div key={r.rule_type} className={styles.flex_row}>
              <Checkbox
                checked={field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)}
                onClick={(e) => toggleRule(e.target.checked, r.rule_type, "")}
                size="small"
              />
              <div>{r.name}</div>
              {!["not_future", "not_past", "after_randomization"].includes(r.rule_type) ? (
                <div className={styles.entry_rule_text_wrapper}>
                  <TextField
                    sx={datefield_sx}
                    inputProps={{
                      maxLength: r.rule_type.includes("age") ? 4 : 10,
                    }}
                    placeholder={r.rule_type.includes("age") ? "" : "YYYY-MM-DD"}
                    value={field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)?.value || ""}
                    disabled={!field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)}
                    onChange={(e) => toggleRule(true, r.rule_type, e.target.value)}
                  />
                </div>
              ) : null}
            </div>
          ))}
        </div>
      ) : null}
      {["datetime"].includes(field.type) ? (
        <div>
          {[
            { name: "not future", rule_type: "not_future" },
            { name: "not past", rule_type: "not_past" },
            {
              name: "after randomization date",
              rule_type: "after_randomization",
            },
            {
              name: "before randomization date",
              rule_type: "before_randomization",
            },
          ].map((r) => (
            <div key={r.rule_type} className={styles.flex_row}>
              <Checkbox
                checked={field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)}
                onClick={(e) => toggleRule(e.target.checked, r.rule_type, "")}
                size="small"
              />
              <div>{r.name}</div>
            </div>
          ))}
        </div>
      ) : null}
      {["int", "blood_pressure"].includes(field.type) ? (
        <div>
          {[
            { name: "min", rule_type: "min" },
            { name: "max", rule_type: "max" },
          ].map((r) => (
            <div key={r.rule_type} className={styles.flex_row}>
              <Checkbox
                checked={field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)}
                onClick={(e) => toggleRule(e.target.checked, r.rule_type, "")}
              />
              <div>{r.name}</div>
              <div className={styles.entry_rule_text_wrapper}>
                <TextField
                  sx={textfield_sx}
                  inputProps={{ maxLength: 4 }}
                  value={field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)?.value || ""}
                  disabled={!field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)}
                  onChange={(e) => toggleRule(true, r.rule_type, e.target.value)}
                />
              </div>
            </div>
          ))}
        </div>
      ) : null}
      {field.type === "blood_pressure_date_time" ? (
        <div>
          {[
            { name: "min", rule_type: "min" },
            { name: "max", rule_type: "max" },
          ].map((r) => (
            <div key={r.rule_type} className={styles.flex_row}>
              <Checkbox
                checked={field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)}
                onClick={(e) => toggleRule(e.target.checked, r.rule_type, "")}
              />
              <div>{r.name}</div>
              <div className={styles.entry_rule_text_wrapper}>
                <TextField
                  sx={textfield_sx}
                  inputProps={{ maxLength: 4 }}
                  value={field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)?.value || ""}
                  disabled={!field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)}
                  onChange={(e) => toggleRule(true, r.rule_type, e.target.value)}
                />
              </div>
            </div>
          ))}

          {[
            {
              name: "after randomization date",
              rule_type: "after_randomization",
            },
          ].map((r) => (
            <div key={r.rule_type} className={styles.flex_row}>
              <Checkbox
                checked={field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)}
                onClick={(e) => toggleRule(e.target.checked, r.rule_type, "")}
                size="small"
              />
              <div>{r.name}</div>
            </div>
          ))}
        </div>
      ) : null}
      {field.type === "decimal" ? (
        <div>
          {[
            { name: "min", rule_type: "min" },
            { name: "max", rule_type: "max" },
          ].map((r) => (
            <div key={r.rule_type} className={styles.flex_row}>
              <Checkbox
                checked={field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)}
                onClick={(e) => toggleRule(e.target.checked, r.rule_type, "")}
                size="small"
              />
              <div>{r.name}</div>
              <div className={styles.entry_rule_text_wrapper}>
                <TextField
                  sx={textfield_sx}
                  inputProps={{ maxLength: 4 }}
                  value={field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)?.value || ""}
                  disabled={!field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)}
                  onChange={(e) => toggleRule(true, r.rule_type, e.target.value)}
                />
              </div>
            </div>
          ))}
        </div>
      ) : null}
      {field.type === "weight" ? (
        <div>
          {[
            { name: "min", rule_type: "min" },
            { name: "max", rule_type: "max" },
          ].map((r) => (
            <div key={r.rule_type} className={styles.flex_row}>
              <Checkbox
                checked={field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)}
                onClick={(e) => toggleRule(e.target.checked, r.rule_type, "", { unit: "kg" })}
                size="small"
              />
              <div>{r.name}</div>
              <div className={styles.entry_rule_text_wrapper}>
                <TextField
                  sx={textfield_sx}
                  inputProps={{ maxLength: 4 }}
                  value={field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)?.value || ""}
                  disabled={!field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)}
                  onChange={(e) => {
                    let unit = field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)?.unit || "";
                    toggleRule(true, r.rule_type, e.target.value, {
                      unit,
                    });
                  }}
                />
              </div>
              <div className={styles.entry_rule_text_wrapper}>
                <Select
                  value={field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)?.unit || "kg"}
                  sx={{
                    fontSize: 14,
                    width: 80,
                    height: 30,
                    padding: 0,
                    alignSelf: "center",
                  }}
                  onChange={(e) => {
                    let value = field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)?.value || "";
                    toggleRule(true, r.rule_type, value, {
                      unit: e.target.value,
                    });
                  }}
                  disabled={!field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)}
                >
                  <MenuItem value={"kg"} sx={{ textOverflow: "ellipsis" }}>
                    kg
                  </MenuItem>
                  <MenuItem value={"lb"} sx={{ textOverflow: "ellipsis" }}>
                    lb
                  </MenuItem>
                </Select>
              </div>
            </div>
          ))}
        </div>
      ) : null}
      {field.type === "blood_test_result" ? (
        <div>
          {[
            { name: "int min", rule_type: "int_min" },
            { name: "int max", rule_type: "int_max" },
            { name: "decimal min", rule_type: "decimal_min" },
            { name: "decimal max", rule_type: "decimal_max" },
          ].map((r) => (
            <div key={r.rule_type} className={styles.flex_row}>
              <Checkbox
                checked={field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)}
                onClick={(e) => toggleRule(e.target.checked, r.rule_type, "")}
                size="small"
              />
              <div>{r.name}</div>
              <div className={styles.entry_rule_text_wrapper}>
                <TextField
                  sx={textfield_sx}
                  inputProps={{ maxLength: 4 }}
                  value={field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)?.value || ""}
                  disabled={!field.entry_rules?.find((rule) => rule.rule_type === r.rule_type)}
                  onChange={(e) => toggleRule(true, r.rule_type, e.target.value)}
                />
              </div>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
